import { render, staticRenderFns } from "./CustomFonts.vue?vue&type=template&id=7b1ab3c0&"
import script from "./CustomFonts.vue?vue&type=script&lang=js&"
export * from "./CustomFonts.vue?vue&type=script&lang=js&"
import style0 from "./CustomFonts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports